import axiosInstance from "./axiosInstance";

// Get all videos BEFORE SEPARATING THE ADMIN SECTIONS
// export const getVideos = async (category) => {
//   console.log("🔵 Making API request to /videos...");
//   try {
//     // const res = await axiosInstance.get("/videos");
//     const res = await axiosInstance.get(`/videos${category ? `?category=${category}` : ""}`);

//     console.log("🟢 API response in getVideos:", res.data);
//     return res.data.videos;
//   } catch (error) {
//     console.error("Error fetching videos from API:", error);
//     throw error;
//   }
// };

// GET ALL VIDEOS AFTER SEPARATING THE ADMIN SECTIONS
export const getVideos = async (category) => {
  try {
    if (!category) {
      throw new Error("Category is required for fetching videos.");
    }

    console.log(`🔵 Fetching videos for category: ${category}`);
    const res = await axiosInstance.get(`/videos?category=${encodeURIComponent(category)}`);
    
    console.log("🟢 API response in getVideos:", res.data);
    return res.data.videos;
  } catch (error) {
    console.error("❌ Error fetching videos:", error.response?.data || error.message);
    throw error;
  }
};


// Get a single video by ID
export const getVideoById = async (id) => {
  const res = await axiosInstance.get(`/videos/${id}`);
  return res.data.video;
};

// Upload a video BEFORE SEPARATING THE ADMIN SECTIONS
// export const uploadVideo = async (formData) => {
//   const res = await axiosInstance.post("/videos/upload", formData, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });
//   return res.data.video;
// };

// UPlOAD VIDEO AFTER SEPARATING THE ADMIN SECTIONS
export const uploadVideo = async (formData) => {
  if (!formData.has("category")) {
    throw new Error("Category is required for uploading videos.");
  }

  const res = await axiosInstance.post("/videos/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res.data.video;
};

// CREATE EXTERNAL VIDEO BEFORE SEPARATING ADMIN SECTIONS
// export const createExternalVideo = async (videoData) => {
//   const res = await axiosInstance.post("/videos/external", videoData, {
//     headers: { "Content-Type": "application/json" },
//   });
//   return res.data.video; // ✅ Returns the created external video
// };

// CREATE EXTERNAL VIDEO AFTER SEPARATING ADMIN SECTIONS
export const createExternalVideo = async (videoData) => {
  try {
    console.log("📤 Sending external video data:", videoData);

    const res = await axiosInstance.post("/videos/external", videoData);
    
    console.log("✅ API Response for createExternalVideo:", res.data);
    return res.data.video;
  } catch (error) {
    console.error("❌ Error creating external video:", error.response?.data || error.message);
    throw error;
  }
};


// Update a video by ID
export const updateVideo = async (id, formData) => {
  const res = await axiosInstance.put(`/videos/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data.video;
};

// Delete a video by ID BEFORE SEPARATING ADMIN SECTIONS
// export const deleteVideo = async (id) => {
//   const res = await axiosInstance.delete(`/videos/${id}`);
//   return res.data;
// };

// Delete a video by ID after SEPARATING ADMIN SECTIONS
// export const deleteVideo = async (id, category) => {
//   if (!category) throw new Error("Category is required for deleting videos.");

//   const res = await axiosInstance.delete(`/videos/${id}?category=${category}`);
//   return res.data;
// };

export const deleteVideo = async (id) => {
  if (!id) throw new Error("Video ID is required for deleting videos.");

  const res = await axiosInstance.delete(`/videos/${id}`);
  return res.data;
};
